export default "__VITE_ASSET__BAApJ5oT__"